export default {
  lang: '语言',
  currency: '货币',
  validGoodUrlFail: '这不是正确的商品链接',
  product: '商品',
  productHolder: '输入商品名称/链接',
  shop: '店铺',
  shopHolder: '输入店铺名称/店铺链接',
  purchaseAgent: '首页',
  transport: '转运',
  manualOrdering: '手动下单',
  guideBook: '指南手册',
  help: '帮助',
  tools: '工具',
  customerService: '客户服务',
  purchaseGuide: '代购指南',
  payment: '支付',
  delivery: '配送',
  afterSaleService: '售后服务',
  insuranceCompensation: '保险和赔偿',
  contactInfo: '联系信息',
  enterEmail: '输入您的邮箱',
  copyRight: '版权所有©acbuy.com',
  aboutacbuy: '关于acbuy',
  contctTime: '9/7（09:00-18:00，北京时间）',
  contactEmail: "客服邮箱：Support{'@'}acbuy.com",
  contactMarket: "市场合作：Marketing{'@'}acbuy.com",
  contactCooperation: "商务合作：Business{'@'}acbuy.com",
  tutorial: '教程',
  serviceFee: '服务费',
  orderStatus: '新手指南',
  returnRefunds: '退货和退款',
  topUp: '充值',
  paypal: 'PayPal',
  internationalCreditCard: '国际信用卡',
  telegraphicTransfer: '电汇',
  charges: '费用',
  mailRestrictions: '邮寄限制',
  customsTaxation: '海关和税收',
  receiptInformation: '收据信息',
  helpCenter: '帮助中心',
  contactUs: '联系我们',
  registerSuccess: '注册成功',
  registerMsg: '我们已向您的邮箱发送验证邮件。请及时完成验证，否则将影响您积分的正常使用。',
  continueShopping: '继续购物',
  continueLogin: '继续登录',
  verifyQuestion: '没有收到验证邮件？',
  verifyResopnseOne: '· acbuy验证邮件可能被误认为垃圾邮件，请检查您的垃圾邮件文件夹',
  verifyResopnseTwo: '· 发送可能会延迟几分钟，请耐心等待',
  verifyResopnseThird:
    '· 验证邮件可能会延迟几分钟。如果长时间未收到邮件，您可以检查是否被标记为垃圾邮件或重新发送验证邮件',
  agentGuide: '新手代购指南',
  guideBookbtn: '新手指南手册',
  everyonePro: '立即注册，即可获得¥2280的欢迎礼物！',
  joinAffiliate: '领取',
  joinacbuy: '加入acbuy Discord获取更多福利',
  joinDiscord: '加入Discord',
  productPpurchase: '商品购买',
  shippingToWarehouse: '发货到仓库',
  qualityAssurance: '质量保证',
  moreCostEffective: '更具性价比',
  productPpurchaseContent:
    '商品购买 - 您可以轻松从淘宝购买任何商品。只需将淘宝商品链接粘贴到acbuy网站并下单，acbuy将为您购买。',
  shippingToWarehouseContent:
    '发货到仓库 – 通过我们的服务从不同卖家购物，我们将高效整合您的采购订单。所有商品都将运送到acbuy指定仓库，我们将简化流程，为您提供便利。',
  qualityAssuranceContent:
    '质量保证 - 当您的商品到达acbuy指定仓库后，我们将对您的商品进行全面的质量检查，并向您发送检查反馈，为您提供更好的使用体验。',
  moreCostEffectiveContent:
    '集中运输省钱 - 在您的仓库中，您可以自由选择商品并通过一个包裹发货。使用acbuy的全球运输服务，您可以将商品运送到任何地方，享受更简单可靠的全球运输。',
  introduction: '通过acbuy在淘宝上购物',
  logoIntroduction: 'Shop like a millionaire.',
  reviewOn: '评论',
  productStoragePeriod: '产品储存期',
  inspectionRules: '检验规则',
  afterSalesPolicy: '售后政策',
  insuranceAndCompensation: '保险与赔偿',
  oneStopService: '一站式服务',
  whatCustomersSay: '用户评价',
  customerSay1:
    'acbuy是我用过的最好的购物代理——这是我第一次使用acbuy，它的产品比其他任何购物代理都便宜，这真是太棒了！',
  customerSay2:
    '在成为acbuy的推广人员后，我收到了300元的现金返还。之后，我将获得每笔订单不低于4%的现金返还',
  customerSay3: '非常愉快的购物体验-我使用acbuy从中国购物，产品质量好，客户服务好，发货快。',
  customerSay4: '最好的代理商-购买在同一天完成。把包裹送到我家只花了7天时间。这是目前最好的代理人',
  customerFirst: '客户至上，优质服务',
  customerServiceText: '9/7在线客服（09:00-18:00，北京时间）',
  faqCategory: 'FAQ类别',
  valentine: '情人节神秘盲盒惊喜',
  joinDiscordNew: '点击加入',
  valentineTip: '加入Discord，获取专属礼物',
  inviteNow: '马上邀请',
  inviteMore: '邀请越多，赢得越多！',
  comeHere: '更多精彩奖励等你来拿！',
  viewTutorial: '查看教程',
  springText1: '如何通过 Acbuy 在淘宝购物',
  springText2: '邀请好友并赢取¥2000现金奖励',
  springText3: '活动时间：4月18号-5月20号',
  category: '分类',
  hotSale: '热销商品',
  motherText1: '专属母亲节优惠',
  motherText2: '赢取奖品 – 立即参加!',
  motherText3: '活动时间：4月30日 – 5月13日',
  enterNow: '立即参加',
  'i18n-000001': '下单',
  'i18n-000002': '粘贴商品链接以提交订单',
  'i18n-000003': '质检&存储',
  'i18n-000004': '提供3-5张QC图和90天免费存储',
  'i18n-000005': '提包',
  'i18n-000006': '组合打包&检查包裹',
  'i18n-000007': '国际物流',
  'i18n-000008': '超过150家便宜的物流线路',
  loveText1: '加入520活动',
  loveText2: '下单越多，奖励越大！',
  loveText3: '活动时间：5月14日 – 5月24日',
  couponResult: '找到 {num} 个"{keyword}"结果',
  event: '活动公告',
}
